import { makeOptionsData } from 'Common/FormHelper';

export const groupByOptions = [
  { value: 1, label: 'Site' },
  { value: 2, label: 'Day' },
  { value: 3, label: 'Route' },
];

export const GroupByOptionsEnum = {
  SITE: 1,
  DAY: 2,
  ROUTE: 3,
};

const WEEK_DAYS = [
  { Id: 0, Description: 'Sunday' },
  { Id: 1, Description: 'Monday' },
  { Id: 2, Description: 'Tuesday' },
  { Id: 3, Description: 'Wednesday' },
  { Id: 4, Description: 'Thursday' },
  { Id: 5, Description: 'Friday' },
  { Id: 6, Description: 'Saturday' },
];

export const weekDayOptions = makeOptionsData(WEEK_DAYS);




// WEBPACK FOOTER //
// ./src/pages/reports/inventory/truckroutereport/helper/index.js